import { takeLatest } from 'redux-saga/effects';
import {
  getReportListSuccess, getReportListFail,
  getReportDetailsSuccess, getReportDetailsFail
} from './reportState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/reports');
const redirectData = {route:'/console/reports', mode: 'list', recordId:0 };
const modelName = 'Report';
const modelId = 'rpt_id';

function* getReportList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getReportListSuccess, 
		getReportListFail);
}

function* getReportDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getReportDetailsSuccess, 
		getReportDetailsFail);		
}

function* doReportCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getReportDetailsSuccess, 
		getReportDetailsFail,
		`${modelName} record has been created.`,
		redirectData);
}

function* doReportUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getReportDetailsSuccess, 
		getReportDetailsFail,
		`${modelName} record has been updated.`,
		redirectData);	
}

function* doReportDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getReportDetailsSuccess, 
		getReportDetailsFail,
		`${modelName} record has been deleted.`,
		{...redirectData, mode: data.payload.mode});	
}

function* reportSaga() {
  yield takeLatest('report/getReportList', getReportList);
  yield takeLatest('report/getReportDetails', getReportDetails);
  yield takeLatest('report/doReportCreate', doReportCreate);
  yield takeLatest('report/doReportUpdate', doReportUpdate);
  yield takeLatest('report/doReportDelete', doReportDelete);  
}

export default reportSaga;
